import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AssignmentCommunicationNotesPostModel } from '../../../models/assignment-communication-note-post.model';
import { AssignmentsCommunicationStateService } from '../../../services/assignments-communication-state-service';
import { AssignmentsCommunicationService } from '../../../services/assignments-communication.service';
import { AssignmentChangeCommunicationResultModel } from '../../../models/assignment-change-communication-result.model';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-assignment-communication-notes-modal',
    templateUrl: './assignment-communication-notes-modal.component.html',
    styleUrl: './assignment-communication-notes-modal.component.scss'
})
export class AssignmentCommunicationNotesModalComponent implements OnInit {
    noteResponse: AssignmentChangeCommunicationResultModel | null = null;
    assignmentCommunicationNoteModel?: AssignmentCommunicationNotesPostModel;
    noteForm: FormGroup | null = null;
    assignmentId!: number;
    isLoading: boolean = false;

    constructor(
        private assignmentCommunicationStateService: AssignmentsCommunicationStateService,
        private assignmentCommunicationService: AssignmentsCommunicationService,
        private formBuilder: FormBuilder,
        private bsModalRef: BsModalRef
    ) { }

    ngOnInit(): void {
        this.loadData();
    }

    private loadData(): void {
        this.assignmentCommunicationService.getAssignmentCommunication(this.assignmentId)
            .subscribe({
                next: (communicationModel) => {
                    this.isLoading = false
                    this.initForm(communicationModel.note);
                }
            });
    }

    public saveForm(): void {
        if (this.noteForm == null) return;
        if (!this.noteForm.valid) return;

        this.sendAssignmentCommunicationNotes();
    }

    private sendAssignmentCommunicationNotes(): void {
        this.isLoading = true;

        this.assignmentCommunicationNoteModel = { note: this.noteForm?.value.note };
        this.assignmentCommunicationService.sendAssignmentCommunicationNote(this.assignmentId, this.assignmentCommunicationNoteModel)
            .subscribe({
                next: (response) => {
                    this.isLoading = false;
                    if (response.isSuccess) {
                        this.assignmentCommunicationStateService.loadAssignmentCommunication(this.assignmentId);
                        this.bsModalRef.hide();
                    }
                    this.noteResponse = response;
                },
                error: (error) => {
                    this.isLoading = false;
                }
            });
    }

    private initForm(value: string): void {
        this.noteForm = this.formBuilder.group({
            note: [value]
        });
    }
}
